<template>
  <div class="library-page">
    <!-- 顶部导航 -->
    <!-- <AppHeader /> -->

     <!-- 1. Banner 区域 (深色) -->
 <section class="lib-banner">
  <div class="container">
    <div class="banner-content">
      <h1>AI数字人相框系统</h1>
      <p class="subtitle">校园智能新体验，让师生生活更美好</p>
      <p class="description">融合AI数字人、语音交互与云端服务，打造校园智能知识伙伴，陪伴每一位学生成长。</p>
      
      <!-- 四个功能特性 -->
      <div class="features">
        <div class="feature-item" v-for="(feature, index) in featuresdata" :key="index">
          <div class="feature-icon">
            <!-- 使用 img 标签引入本地图片图标 -->
            <img :src="feature.icon" :alt="feature.title" class="icon-img" />
          </div>
          <h3>{{ feature.title }}</h3>
        </div>
      </div>
      
      <!-- <button class="btn-primary" @click="contactUs">
        合作咨询 <span class="divider">|</span> 020-82038386
      </button> -->
    </div>
  </div>
</section>

    <!-- 2. 核心功能 (白色背景) -->
     <!-- 2. 核心功能 (白色背景) -->
  <section class="lib-features">
  <div class="container">
    <div class="section-title">
      <h2>核心功能</h2>
      <!-- 如果图片中没有副标题，可以注释掉下面这行 -->
      <!-- <p class="subtitle">以AI赋能校园服务，让沟通更自然，让服务更智能</p> -->
    </div>
    
    <div class="features-grid">
      <!-- 卡片 1：语音知识问答 -->
      <div class="feature-card">
        <div class="icon-box">
          <!-- 请替换为实际的语音图标路径 -->
          <img src="../assets/images/icon-voice.png" loading="lazy" alt="语音图标" class="feature-icon">
        </div>
        <h4>语音知识问答</h4>
        <p>免触语音问答，自然提问，<br>即问即答。</p>
      </div>

      <!-- 卡片 2：知名人物数字人 -->
      <div class="feature-card">
        <div class="icon-box">
          <!-- 请替换为实际的数字人/书本图标路径 -->
          <img src="../assets/images/icon-digital.png" loading="lazy" alt="数字人图标" class="feature-icon">
        </div>
        <h4>知名人物数字人</h4>
        <p>知名人物数字人形象，<br>交互科普，启迪成长。</p>
      </div>

      <!-- 卡片 3：云端统一运维 -->
      <div class="feature-card">
        <div class="icon-box">
          <!-- 请替换为实际的云端图标路径 -->
          <img src="../assets/images/icon-cloud.png" loading="lazy" alt="云端图标" class="feature-icon">
        </div>
        <h4>云端统一运维</h4>
        <p>数字人形象、内容知识库，<br>云端统一管理与更新。</p>
      </div>

      <!-- 卡片 4：软硬件一体化 -->
      <div class="feature-card">
        <div class="icon-box">
          <!-- 请替换为实际的设备图标路径 -->
          <img src="../assets/images/icon-device.png" loading="lazy" alt="设备图标" class="feature-icon">
        </div>
        <h4>软硬件一体化</h4>
        <p>自研终端设备+系统平台深度融合，<br>远程运维，安全文档。</p>
      </div>
    </div>
  </div>
</section>

    <!-- 3.  产品优势 -->
  <!-- 3. 产品优势 -->
  <section class="lib-terminal">
    <div class="container">
      <div class="section-title">
        <h2>产品优势</h2>
      </div>
      
      <div class="terminal-layout">
        <!-- 左侧功能点 -->
        <div class="terminal-features side-features">
          <div class="tf-item" v-for="(item, index) in leftFeatures" :key="'l'+index">
            <div class="icon-box">
              <img :src="item.icon" :alt="item.title" class="feature-icon">
            </div>
            <div class="tf-content">
              <h4 class="feature-title">{{ item.title }}</h4>
              <p class="feature-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>

        <!-- 中间设备图 -->
        <div class="terminal-device">
          <div class="device-frame">
            <img src="../assets/images/terminal-card-device.png" loading="lazy" alt="智能终端设备" class="device-img">
          </div>
        </div>

        <!-- 右侧功能点 -->
        <div class="terminal-features side-features">
          <div class="tf-item" v-for="(item, index) in rightFeatures" :key="'r'+index">
            <div class="icon-box">
              <img :src="item.icon" :alt="item.title" class="feature-icon">
            </div>
            <div class="tf-content">
              <h4 class="feature-title">{{ item.title }}</h4>
              <p class="feature-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
<!-- 4. 产品优势 (极淡背景) -->
<!-- <section class="lib-advantages">
  <div class="container">
    <div class="section-title">
      <h2>产品优势</h2>
      <p class="subtitle">专业的技术与服务团队，保障系统稳定运行</p>
    </div>
    <div class="adv-grid">
      <div class="adv-item" v-for="adv in advantages" :key="adv.id">
        <h4>{{ adv.title }}</h4>
        <p>{{ adv.desc }}</p>
      </div>
    </div>
  </div>
</section> -->

<!-- 5. 应用场景 (白色背景) -->
<!-- <section class="lib-scenarios">
  <div class="container">
    <div class="section-title">
      <h2>应用场景</h2>
    </div>
    <div class="scenarios-grid">
      <div class="scenario-card" v-for="scene in scenarios" :key="scene.id">
        <div class="scenario-img-box">
          <img :src="scene.img" :alt="scene.title" class="scene-img">
        </div>
        <div class="scenario-info">
          <h4>{{ scene.title }}</h4>
          <p>{{ scene.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</section> -->

    <!-- 底部 -->
    <AppFooter />

    <!-- 悬浮返回按钮 -->
    <button class="back-btn" @click="goBack">← 返回产品矩阵</button>
  </div>
</template>

<script>
// import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'AILibrarySearch',
  components: {  AppFooter },
  data() {
    return {
      featuresdata: [
  { title: '知人知史', icon: require('../assets/images/icon-history.png') }, 
  { title: '启迪成长', icon: require('../assets/images/icon-growth.png') },
  { title: '服务校园', icon: require('../assets/images/icon-service.png') },
  { title: '智慧互联', icon: require('../assets/images/icon-smart.png') }
],
      features: [
  {
    id: 1,
    title: '实时语音交互',
    desc: '支持自然语音理解与对话，毫秒级响应，沟通更流畅。'
  },
  {
    id: 2,
    title: '校园智能问答',
    desc: '基于知识库与大模型能力，精准解答各类问题。'
  },
  {
    id: 3,
    title: '多模态交互',
    desc: '语音、文字多模态交互，满足不同场景需求。'
  },
  {
    id: 4,
    title: '软硬件一体化',
    desc: '智能终端设备+系统平台深度融合，远程运维，安全文档。' 
    // 注：图片中文字较模糊，看起来像“字眼”，此处根据语境修正为“智能”或保留原意，请根据实际情况调整
  }
],
     terminalFeatures: [
  { text: '27英寸触控大屏，高清显示' },
  { text: '阵列麦克风+高清摄像头，语音识别更精准' },
  { text: '工业级设计，稳定耐用' },
  { text: '支持壁挂/落地多种安装方式' },
  { text: '支持系统远程升级与设备管理' }
],
    advantages: [
  { 
    id: 1, 
    title: 'AI技术领先', 
    desc: '融合大模型与知识图谱，持续提升理解与服务能力' 
  },
  { 
    id: 2, 
    title: '数据安全可靠', 
    desc: '本地化部署与多重安全机制，保障校园数据安全' 
  },
  { 
    id: 3, 
    title: '快速接入落地', 
    desc: '标准化接口与灵活部署方案，快速上线，按需扩展' 
  },
  { 
    id: 4, 
    title: '专业服务支持', 
    desc: '7×24小时运维支持，持续优化使用体验' 
  }
],
    scenarios: [
      { 
        id: 1, 
        title: '教学楼/图书馆', 
        desc: '资源检索、知识问答、知识科普',
        img: require('@/assets/images/scene-school.png') // 替换为真实路径
      },
      { 
        id: 2, 
        title: '学生社区/宿舍区', 
        desc: '生活服务、报修投诉、通知公共',
        img: require('@/assets/images/scene-university.png')
      },
      { 
        id: 3, 
        title: '行政服务大厅', 
        desc: '办事咨询、流程引导、政策解读',
        img: require('@/assets/images/scene-public.png')
      },
      { 
        id: 4, 
        title: '校园门口/广场', 
        desc: '迎新导览、校园介绍、活动咨询',
        img: require('@/assets/images/scene-enterprise.png')
      }],
       // 左侧功能数据
      leftFeatures: [
        {
          title: '安全可靠 隐私保护',
          desc: '数据传输加密，严格权限管理，保障学生信息与数据安全。',
          icon: require('@/assets/images/icon-shield-check.png') // 请替换为实际图标
        },
        {
          title: '稳定耐用 智能硬件',
          desc: '工业级硬件方案，7x24小时稳定运行，适应校园多场景。',
          icon: require('@/assets/images/icon-hardware.png') // 请替换为实际图标
        }
      ],
      // 右侧功能数据
      rightFeatures: [
        {
          title: '内容丰富 持续更新',
          desc: '名人资源、知识内容持续扩充，紧跟教育热点与时代发展。',
          icon: require('@/assets/images/icon-cube.png') // 请替换为实际图标
        },
        {
          title: '数据分析 精准运营',
          desc: '使用数据可视化分析，助力校园服务与教学优化。',
          icon: require('@/assets/images/icon-chart.png') // 请替换为实际图标
        }
      ]
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    },
    contactUs() {
      alert('联系电话：020-82038386')
    }
  }
}
</script>

<style scoped>
.container { 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

/* 1. Banner (深色背景图) */
.lib-banner {
  position: relative;
  /* 左侧浅色背景，与图片左侧融合 */
  background-color: #f0f7fb;
  background-image: url('../assets/images/AIVoiceInteraction.png');
  /* 高度填满容器，宽度自动按比例缩放 */
  background-size: auto 100%;
  /* 靠右对齐，确保右侧数字人/相框完整显示 */
  background-position: right center;
  background-repeat: no-repeat;
  padding: 0;
  height: 750px; /* 增加高度以容纳四个图标和描述 */
  display: flex;
  align-items: center;
  overflow: hidden;
}

/* 极淡的白色渐变遮罩，确保左侧深色文字在复杂背景上依然清晰 */
.lib-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 65%;
  height: 100%;
  background: linear-gradient(to right, rgba(240, 247, 251, 0.95) 0%, rgba(240, 247, 251, 0.6) 50%, transparent 100%);
  pointer-events: none;
  z-index: 1;
}

.lib-banner .container { 
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 5%;
  display: flex;
  align-items: center;
}

.banner-content { 
  flex: 1;
  max-width: 700px;
}

.banner-content h1 { 
  font-size: 52px; 
  line-height: 1.2; 
  margin-bottom: 16px; 
  font-weight: 800;
  color: #0f172a; 
  letter-spacing: -0.5px;
}

.subtitle { 
  font-size: 22px; 
  color: #334155; 
  margin-bottom: 16px; 
  font-weight: 600;
}

.description {
  font-size: 15px;
  color: #64748b;
  line-height: 1.8;
  margin-bottom: 48px;
  max-width: 600px;
}

/* 功能特性区域 */
.features {
  display: flex;
  gap: 32px;
  margin-bottom: 48px;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
}

.feature-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 可选：给图标加一个浅色圆形/圆角背景，让它更突出 */
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.08);
  padding: 8px;
}

/* 控制引入的图片图标尺寸 */
.icon-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.feature-item h3 {
  font-size: 15px;
  color: #0f172a;
  margin: 0;
  font-weight: 600;
}

.btn-primary { 
  background: #0ea5e9;
  color: #fff; 
  border: none; 
  padding: 14px 36px;
  border-radius: 30px; 
  font-size: 16px; 
  cursor: pointer; 
  transition: all 0.3s;
  /* display: inline-flex; */
  align-items: center;
  gap: 8px;
  font-weight: 600;
  box-shadow: 0 4px 14px rgba(14, 165, 233, 0.3);
}

.btn-primary:hover { 
  background: #0284c7;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(14, 165, 233, 0.4);
}

.divider {
  opacity: 0.7;
  margin: 0 4px;
  font-weight: 400;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .lib-banner {
    height: 750px;
  }
  .banner-content h1 {
    font-size: 44px;
  }
  .features {
    gap: 20px;
  }
}

@media (max-width: 992px) {
  .lib-banner {
    height: 550px;
    background-position: center; /* 平板端背景居中 */
  }
  
  .lib-banner::before {
    width: 100%;
    background: rgba(240, 247, 251, 0.9); /* 平板端全遮罩保护文字 */
  }

  .banner-content {
    max-width: 100%;
    text-align: center;
  }
  
  .description {
    margin-left: auto;
    margin-right: auto;
  }

  .features {
    justify-content: center;
    flex-wrap: wrap;
    gap: 24px;
  }

  .feature-item {
    flex: 0 0 calc(50% - 12px);
  }
}

@media (max-width: 768px) {
  .lib-banner {
    height: 700px; /* 手机端增加高度适应纵向排列 */
  }
  
  .banner-content h1 {
    font-size: 32px;
  }
  
  .subtitle {
    font-size: 18px;
  }
  
  .description {
    font-size: 14px;
    margin-bottom: 32px;
  }

  .features {
    flex-direction: column;
    gap: 20px;
  }

  .feature-item {
    flex-direction: row;
    align-items: center;
    text-align: left;
    gap: 16px;
  }
  
  .feature-icon {
    width: 44px;
    height: 44px;
    margin-bottom: 0;
    flex-shrink: 0;
  }

  .btn-primary {
    width: 100%;
    justify-content: center;
  }
}
/* 2. Features (白色) */
.lib-features { 
  padding: 80px 0; 
  background: #f8fafc; /* 浅蓝灰色背景 */
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title { 
  text-align: center; 
  margin-bottom: 50px; 
}

.section-title h2 { 
  font-size: 32px; 
  color: #0f172a; 
  margin-bottom: 12px;
  font-weight: bold;
  margin-top: 0;
}

.section-title .subtitle {
  font-size: 16px;
  color: #475569; 
  font-weight: 600;
  margin: 0;
}

.features-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 24px; 
}

.feature-card {
  background: #fff; 
  padding: 40px 24px 30px; /* 增加左右内边距 */
  border-radius: 16px; 
  text-align: center; 
  border: 1px solid #f1f5f9; 
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02); 
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feature-card:hover { 
  transform: translateY(-5px); 
  box-shadow: 0 10px 30px rgba(0,0,0,0.05); 
}

/* 修改：图标容器样式，添加虚线框 */
.icon-box {
  width: 72px;  /* 稍微加大容器 */
  height: 72px; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  margin-bottom: 20px; /* 图标与标题的间距 */
  /* border: 1px dashed #94a3b8;  */
  border-radius: 8px; /* 圆角 */
  background-color: #fff;
}

.feature-icon {
  width: 72px; /* 图标本身大小 */
  height: 72px;
  object-fit: contain;
  /* 如果原图是黑色的，取消注释下面这行变蓝 */
  /* filter: invert(43%) sepia(93%) saturate(1352%) hue-rotate(176deg) brightness(90%) contrast(95%); */
}

.feature-card h4 { 
  margin-top: 0;
  margin-bottom: 12px; 
  color: #1e293b; 
  font-size: 18px; 
  font-weight: bold;
  line-height: 1.4;
}

.feature-card p { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.6;
  margin: 0; 
  /* 去掉了 flex-grow，让内容自然排列 */
}

/* 响应式调整：屏幕变小时改为2列或1列 */
@media (max-width: 1024px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
}
/* 3 */
.lib-terminal { 
  padding: 80px 0; 
  background: #fff;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 32px;
  color: #1e293b;
  font-weight: 700;
}

/* 三列布局 */
.terminal-layout { 
  display: flex; 
  align-items: center; 
  justify-content: space-between;
  gap: 40px; 
}

/* 左右两侧功能列表 */
.terminal-features { 
  flex: 1; 
  display: flex; 
  flex-direction: column; 
  gap: 40px; /* 上下两个功能点的间距 */
}

.tf-item {
  display: flex; 
  align-items: flex-start; /* 顶部对齐 */
  gap: 20px; 
}

/* 图标外面的虚线框 */
.icon-box {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  /* border: 1px dashed #bae6fd;  */
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0,0,0,0.02);
}

.feature-icon {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.tf-content {
  flex: 1;
  padding-top: 5px; /* 微调文字位置 */
}

.feature-title {
  font-size: 18px;
  color: #1e293b;
  font-weight: 700;
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.feature-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  line-height: 1.6;
}

/* 中间设备区域 */
.terminal-device { 
  flex: 1.2; /* 中间稍微宽一点 */
  display: flex; 
  justify-content: center;
  align-items: center;
}

/* 中间设备的大虚线框 */
.device-frame {
  width: 100%;
  max-width: 450px;
  /* aspect-ratio: 3/4;  */
  /* border: 2px dashed #cbd5e1;  */
  border-radius: 16px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 20px; */
  box-sizing: border-box;
}

.device-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  /* 给设备图加一点阴影让它更立体 */
  filter: drop-shadow(0 10px 20px rgba(0,0,0,0.1));
}

/* 响应式 */
@media (max-width: 992px) {
  .terminal-layout {
    flex-direction: column;
    gap: 50px;
  }
  
  .terminal-features {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
  }
  
  .tf-item {
    width: calc(50% - 15px);
    background: #f8fafc; /* 移动端给个背景区分 */
    padding: 20px;
    border-radius: 12px;
  }

  .terminal-device {
    order: -1; /* 移动端图片在最上面 */
  }
  
  .device-frame {
    max-width: 300px;
    aspect-ratio: auto;
    height: 400px;
  }
}

@media (max-width: 768px) {
  .tf-item {
    width: 100%;
  }
}
/* 4. Advantages (极淡蓝灰背景) */
.lib-advantages { 
  padding: 80px 0; 
  background: #f8fafc; /* 极淡的背景色 */
}

/* .section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 28px;
  color: #0f172a;
  margin: 0 0 10px 0;
  font-weight: bold;
}

.section-title .subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
} */

.adv-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); /* 修改为4列 */
  gap: 40px; /* 增加间距 */
}

.adv-item {
  text-align: center;
  padding: 20px 10px;
  /* 可选：添加轻微的卡片效果 */
  /* background: #fff; */
  /* border-radius: 8px; */
}

.adv-item h4 { 
  margin-bottom: 12px; 
  color: #1e293b; 
  font-size: 16px; 
  font-weight: 600; /* 加粗 */
}

.adv-item p { 
  font-size: 13px; 
  color: #94a3b8; /* 描述文字颜色更淡一些 */
  line-height: 1.6; 
  margin: 0;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .adv-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .adv-grid {
    grid-template-columns: 1fr;
  }
}

/* 5. Scenarios (白色背景) */
.lib-scenarios { 
  padding: 80px 0; 
  background: #fff; 
}

.scenarios-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 24px; 
}

.scenario-card {
  display: flex;
  flex-direction: column;
  gap: 15px; /* 图片和文字块的间距 */
}

/* 图片区域 */
.scenario-img-box {
  height: 180px;
  border-radius: 12px;
  overflow: hidden;
  background: #f1f5f9;
}

.scene-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 文字信息区域 (浅蓝色背景) */
.scenario-info {
  background: #f0f7ff; /* 浅蓝色背景 */
  padding: 20px 15px;
  border-radius: 12px;
  text-align: center;
}

.scenario-info h4 { 
  margin-bottom: 8px; 
  color: #1e293b; 
  font-size: 16px; 
  font-weight: bold;
}

.scenario-info p { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.5; 
  margin: 0;
}

/* 返回按钮 */
.back-btn {
  position: fixed; bottom: 30px; right: 30px;
  background: #1e293b; color: #fff; border: none;
  padding: 15px 30px; border-radius: 30px;
  cursor: pointer; box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  z-index: 1000; font-size: 16px;
}
.back-btn:hover { background: #334155; }
</style>